module.exports = __webpack_public_path__ + "media/颁奖曲.98b25b9b.mp3";